import { render } from "./AddToCart.vue?vue&type=template&id=7a25cc10"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/3nb/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Demo/AddToCart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a25cc10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a25cc10', __exports__)) {
    console.log('reload')
    api.reload('7a25cc10', __exports__)
  }
  
  module.hot.accept("./AddToCart.vue?vue&type=template&id=7a25cc10", () => {
    console.log('re-render')
    api.rerender('7a25cc10', render)
  })

}


export default __exports__